import { render, staticRenderFns } from "./ShapeConverter.vue?vue&type=template&id=54bc4448&lang=html&"
import script from "./ShapeConverter.vue?vue&type=script&lang=js&"
export * from "./ShapeConverter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports